import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import sensor_actions from '@devices/settings/device_settings/sensor_actions.js';
import external_sensors from '@devices/settings/device_settings/external_sensors.js';
import ext_temperature from '@devices/settings/device_settings/ext_temperature.js';
import ext_humidity from '@devices/settings/device_settings/ext_humidity.js';
import adc_actions from '@devices/settings/device_settings/adc_actions.js';
import adc_automation from '@devices/settings/device_settings/adc_automation.js';
import internet from '@devices/settings/device_settings/internet.js';
import relay_pm_app_settings_no_pm from '@devices/settings/device_settings/app_settings_no_pm_gen_1.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellyuni',
	friendly_name: 'Uni',
	family: 'relay',
	isPM: false,
	modes: {
		relay: {
			channels: 2,
			notifications: ['offline', 'device_problem', 'forgotten_lights'],
			settings: [
				timer,
				schedule,
				actions,
				sensor_actions,
				external_sensors,
				ext_temperature,
				ext_humidity,
				adc_actions,
				adc_automation,
				internet,
				relay_pm_app_settings_no_pm,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'power_on_default', component: 'power_on_default' },
						{ title: 'button_type', component: 'button_type_rr' },
						{ title: 'long_push', component: 'long_push' },
						{ title: 'adc_offset', component: 'adc_offset' },
						{ title: 'adc_range', component: 'adc_range' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'channel_name', component: 'channel_name' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
			hideFromIoActions: [
				'ext_hum_over_url',
				'ext_hum_under_url',
				'ext_temp_over_url',
				'ext_temp_under_url',
				'adc_over_url',
				'adc_under_url',
			],
		},
	},
};
